import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AnomalyBanner } from '../anomaly-banner/anomaly-banner';
import { displayedBanners } from '../anomaly-presentation';
import { AnomalyDisplayState } from '../anomaly.model';
import { AnomalyService } from '../anomaly.service';

/** Les bandeaux des anomalies, sous la barre de navigation, sur toutes les routes. */
@Component({
  selector: 'app-anomaly-banners',
  imports: [AnomalyBanner],
  templateUrl: './anomaly-banners.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./anomaly-banners.scss'],
})
export class AnomalyBanners implements OnInit {
  private readonly anomalyService = inject(AnomalyService);
  private readonly visible = toSignal(this.anomalyService.visible$, { initialValue: [] });

  protected readonly banners = computed(() => displayedBanners(this.visible()));

  ngOnInit(): void {
    this.anomalyService.start();
  }

  protected remember(id: string, displayState: AnomalyDisplayState): void {
    this.anomalyService.setDisplayState(id, displayState).subscribe();
  }
}
